import React, { useState } from "react";
import DashboardLayout from "../../components/DashboardLayout";
import ThemeComp from "../../components/Theme/index";
import { useTranslation } from "react-i18next";

const ThemePage = ({}) => {
  const { t } = useTranslation();

  return (
    <DashboardLayout title={t("theme.themeSettings")} showBackButton={true}>
      <ThemeComp />
    </DashboardLayout>
  );
};

export default ThemePage;
